import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheckboxBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 22,
		height: 22,
		rx: 3,
		fill: "#F7F7F7"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 22,
		height: 22,
		rx: 3,
		stroke: "#868686",
		strokeWidth: 2
	})]
});
export default SvgIconCheckboxBig;
